import React from 'react';
import { createUseStyles } from 'react-jss';
import MenuItem from '../../../MenuItem';

const useStyles = createUseStyles((theme) => ({
  company: {},
  companytitleContainer: {
    composes: 'flexRow',
  },
  companyLogo: {
    marginRight: theme.spacing(2),
    width: 75,
    '& img': {
      width: '100%',
    },
  },
  companyTitle: {
    '& h4': {
      margin: 0,
    },
  },
  companyTitleName: {
    marginBottom: theme.spacing(0.5),
  },
  companyDetail: {},
  companyDetailItems: {
    padding: 0,
  },
}));

const Company = ({ result }) => {
  const classes = useStyles();

  return (
    <div className={classes.company}>
      <div className={classes.companytitleContainer}>
        {result?.cie_logo && (
          <div className={classes.companyLogo}>
            <img alt="" src={'https://' + result?.cie_logo.raw} />
          </div>
        )}
        <div className={classes.companyTitle}>
          <MenuItem 
            label="Nom : " 
            text={result?.cie_name}
            component="h4"
          />
          <MenuItem 
            label="Entity : " 
            text={result?.cie_entity}
            component="h4"
          />
        </div>
      </div>
      <div className={classes.companyDetail}>
        <ul className={classes.companyDetailItems}>
          <MenuItem 
            label="City : " 
            text={result?.cie_city} 
          />

          <MenuItem 
            label="Area : " 
            text={result?.cie_area} 
          />

          <MenuItem 
            label="Country: " 
            text={result?.cie_country} 
          />
        </ul>
      </div>
    </div>
  );
}

export default Company;